<!-- 
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
-->

<template>
  <v-card v-if="visible" class="floating d-flex flex-column">
    <v-card-title class="py-6">
      <div class="text-h5">Draw Route</div>
      <v-spacer></v-spacer>
      <v-btn icon color="blue darken-1" @click="hide">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-subtitle class="py-0">
      Select an endpoint of a line to make a connection to a start point of another line
    </v-card-subtitle>
    <!-- <v-card-text style="overflow-y: scroll; height: calc(50vh - 88px - 54px - 52px);"> -->
    <v-card-text style="overflow-y: scroll; flex-grow: 1;">
      <v-container>
        <v-row dense>
          <v-col>
            <v-checkbox disabled v-model="plotPoints" label="Plot points at begin and end of line" dense>
            </v-checkbox>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col>
            <v-btn @click="undo" :disabled="mpHistory.length < 1"> Undo last connection</v-btn>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col>
            <v-btn disabled @click=""> new route</v-btn>
          </v-col>
          <v-col>
            <v-btn disabled @click=""> edit route</v-btn>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col>
            <v-btn disabled @click="auto"> AUTO</v-btn>
          </v-col>
        </v-row>

      </v-container>
    </v-card-text>
    <v-card-actions>

      <v-btn @click="uploadMotionplan" text :loading="loading"> save</v-btn>

      <v-btn @click="cancel" text> cancel</v-btn>

    </v-card-actions>
  </v-card>
</template>

<script>
import Motionplan from '../../models/Motionplan';


export default {
  components: {},
  data: () => ({
    loading: false,
    visible: false,
    segment: null,
    motionplan: null,
    mpHistory: [],
    plotPoints: true,
  }),
  props: {
    /* Map.vue reference */
    map: {
      required: true,
    },
  },
  computed: {
  },
  watch: {
  },
  methods: {
    uploadMotionplan() {
      this.loading = true
      let data = new FormData();
      data.set("name", this.motionplan.name)
      data.set("file", new File([new Blob([this.motionplan.getMotionplanString()])], "motionplan.log"));

      this.$axios.post(route("api.tasks.addmotionplan", this.map.task.taskId), data, { headers: { "Content-Type": "multipart/form-data" }, }).then((res) => {

        this.map.resetMotionplanCreator()
        this.map.createdMotionplan = null
        this.motionplan = null
        this.hide()

        this.$emit("closeTask");
        this.$emit("openTask", res.data.taskId); // should be task Id?
      }).catch((error) => {
        console.log(error);
      });
    },
    createMotionplan(motionplanData, handle) {
      function getDistance(x1, y1, x2, y2) {
        const dx = x2 - x1;
        const dy = y2 - y1;
        return Math.sqrt(dx * dx + dy * dy);
      }

      console.log(motionplanData)
      if (this.motionplan) {
        let tempMP = new Motionplan(motionplanData)

        // compare distance.
        if (getDistance(this.motionplan.data.at(-1).X, this.motionplan.data.at(-1).Y, tempMP.data.at(0).X, tempMP.data.at(0).Y) < 0.0002) {
          console.log("REMOVE FIRST SEGMENT OF NEW MP")
          tempMP.removeFirstSegment()
        } else {
          const firstSegment = tempMP.data.at(0)
          const lastSegment = this.motionplan.data.at(-1);

          firstSegment.addFunction({ IdentifierFunction: 51, NrOfArgsFunction: 1, Arguments: [0] }) // driveline
          firstSegment.SegmStartAngle = Math.atan2(lastSegment.Y - firstSegment.Y, lastSegment.X - firstSegment.X)
          firstSegment.SegmEndAngle = Math.atan2(lastSegment.Y - firstSegment.Y, lastSegment.X - firstSegment.X)
          firstSegment.length = getDistance(lastSegment.X, lastSegment.Y, firstSegment.X, firstSegment.Y)
        }

        this.mpHistory.push({ lines: tempMP.data.length, handle: handle })

        tempMP.data.forEach(segment => {
          this.motionplan.addSegment(segment.segment)
        });
      } else {
        this.motionplan = new Motionplan(motionplanData, null, handle)
        this.mpHistory = []
      }

      this.map.createdMotionplan = this.motionplan // change to a prop?
    },
    undo() {
      const { lines, handle } = this.mpHistory.pop()
      for (let i = 0; i < lines; i++) {
        this.motionplan.removeLastSegment()
      }
      this.map.createdMotionplan = this.motionplan // change to a prop?
      this.map.redrawMotionplan()
      this.map.deselectFeatureFromHandle(handle)
      this.map.drawMotionplanDrawlineFromPoint(this.motionplan.data.at(-1).X, this.motionplan.data.at(-1).Y)
    },
    show() {
      this.visible = true
    },
    hide() {
      this.map.setPolygonSelectionState(false)
      this.map.resetMotionplanCreator()
      this.map.createdMotionplan = null
      this.$emit("toggleMotionplanCreator");
      Object.assign(this.$data, this.$options.data.apply(this));
    },
    cancel() {
      this.map.resetMotionplanCreator()
      this.map.createdMotionplan = null
      this.motionplan = null
    },
    auto() {
      this.map.setPolygonSelectionState(true)
    }
  },
};
</script>

<style scoped>
.floating {
  z-index: 75;
  position: absolute;
  bottom: 10px;
  left: 10px;
  width: calc(30vw - 10px - 10px);
  height: calc(40vh - 10px);
}
</style>
